import { SIZE, Input } from 'baseui/input';
import { styled } from 'baseui';
import * as React from 'react';
export function DisplayInput(props: any) {
  return <Input size={SIZE.compact} type="text" overrides={{
    Input: {
      style: ({
        $theme
      }) => {
        return {
          borderTopColor: $theme.colors.borderInverseSelected,
          borderBottomColor: $theme.colors.borderInverseSelected,
          borderLeftColor: $theme.colors.borderInverseSelected,
          borderRightColor: $theme.colors.borderInverseSelected,
          backgroundColor: $theme.colors.borderInverseSelected
        };
      }
    },
    InputContainer: {
      style: ({
        $theme
      }) => {
        return {
          borderTopColor: $theme.colors.borderInverseSelected,
          borderBottomColor: $theme.colors.borderInverseSelected,
          borderLeftColor: $theme.colors.borderInverseSelected,
          borderRightColor: $theme.colors.borderInverseSelected
        };
      }
    }
  }} {...props} />;
}
type EditModeInputPropsT = {
  editMode: boolean;
  hideNoneEdit?: boolean;
  children: any;
  value?: string;
};
export function EditModeInput({
  editMode,
  hideNoneEdit = false,
  children,
  value = ''
}: EditModeInputPropsT) {
  if (!editMode) {
    if (hideNoneEdit) {
      return null;
    }
    return <DisplayInput value={value} />;
  }
  return children;
}
export default styled('input', {
  boxSizing: 'border-box',
  fontSize: '16px',
  border: 0,
  // borderBottom: '1px solid',
  width: '100%',
  color: 'inherit',
  background: 'transparent',
  outlineWidth: 0,
  ':focus': {
    outline: 'none'
  }
});